module.exports = __webpack_public_path__ + "d27b73c81664312d64947a23a069bf1b.MP3";